<div class="social-login" *ngIf="enabled">
    <div class="social-btn-wrap">
        <button type="button" class="social-btn" (click)="loginGoogle()">
            <i class="bx bxl-google"></i>
            Se connecter avec Google
        </button>
    </div>
    <div class="social-btn-wrap">
        <button type="button" class="social-btn" (click)="loginFacebook()">
            <i class="bx bxl-facebook"></i>
            Se connecter avec Facebook
        </button>
    </div>
</div>
